'use client'

import { useState } from 'react'

interface OccasionFAQItem {
  question: string
  answer: string
}

interface OccasionFAQProps {
  faqs: OccasionFAQItem[]
}

/**
 * Expand/collapse FAQ accordion — matches the design used by `FeatureFAQ`
 * on the feature pages (e.g. /personal/features/digital-invitations).
 */
export function OccasionFAQ({ faqs }: OccasionFAQProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null)

  return (
    <section className="bg-white py-16 md:py-20">
      <div className="mx-auto max-w-3xl px-6">
        <h2 className="mb-10 text-center text-2xl font-bold text-[#1B0044] md:mb-12 md:text-3xl">
          Frequently Asked Questions
        </h2>
        <div className="space-y-4">
          {faqs.map((faq, i) => {
            const isOpen = openIndex === i
            return (
              <div
                key={i}
                className="overflow-hidden rounded-2xl border border-[#E8DBD0] bg-white shadow-sm"
              >
                <button
                  type="button"
                  className="flex w-full items-center justify-between px-6 py-5 text-left"
                  onClick={() => setOpenIndex(isOpen ? null : i)}
                  aria-expanded={isOpen}
                >
                  <span className="pr-4 font-semibold text-[#1B0044]">{faq.question}</span>
                  <svg
                    className={`h-5 w-5 flex-shrink-0 text-[#FF8A3D] transition-transform ${
                      isOpen ? 'rotate-180' : ''
                    }`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
                {isOpen && (
                  <div className="border-t border-[#E8DBD0] px-6 pb-5 pt-4 leading-relaxed text-[#4F415A]">
                    {faq.answer}
                  </div>
                )}
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}
